var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9271 11.1599L13.6481 15.655L8.88699 13.2185L4.12739 15.655L4.61106 12.629L4.97381 10.3739L3.83265 9.2388L1.18457 6.6013L6.46713 5.77453L8.88699 1.00586L11.3053 5.77453L12.5039 5.96195L16.5879 6.6013L12.8002 10.3739L12.9271 11.1599Z",
    fill: "#101820",
    stroke: "#85673B",
    strokeWidth: 0.302293,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.111 7.08071C14.2676 7.99514 13.0055 9.30105 12.1258 10.2064L12.1561 10.1127C12.3828 11.343 12.6654 13.1235 12.874 14.375L12.9193 14.6501L12.6715 14.5216C11.5394 13.9337 9.94478 13.1205 8.83839 12.5235H8.93664C7.79851 13.0827 6.17671 13.8747 5.03857 14.3962C6.14043 13.7689 7.75014 12.9119 8.88374 12.3058C9.55029 12.6278 10.2093 12.9633 10.8713 13.2928L12.7984 14.2707L12.5959 14.4173C12.3934 13.1326 12.1152 11.3566 11.9354 10.087C12.8649 9.19373 14.1693 7.93468 15.111 7.07617V7.08071Z",
    fill: "#C4944D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72375 10.1303C4.5569 9.13425 3.45353 8.06414 2.36377 6.98344C3.87977 6.74917 5.4003 6.53151 6.93141 6.41211C5.52877 6.74463 4.10649 6.99251 2.68269 7.21923L2.75977 6.98042C3.77699 8.00066 4.78211 9.03752 5.72375 10.1303Z",
    fill: "#C4944D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a1715771b405423c2c1763f19d69b668.svg";
export { ForwardRef as ReactComponent };